const ACTIONS = {
    UPDATE_CANCELLATION_POLICY: 'CANCELLATION_POLICY/UPDATE',
    FAILED_QUOTE_CANCELLATION_POLICY_LOAD: 'QUOTE_CANCELLATION_POLICY/FAILED',
    GET_LISTING_CANCELLATION_POLICY: 'LISTING_CANCELLATION_POLICY/GET'
};

const ACTION_CREATORS = {
    getListingCancellationPolicy(fieldsChanged, isInitialPageLoad = false) {
        return {
            type: ACTIONS.GET_LISTING_CANCELLATION_POLICY,
            payload: {
                fieldsChanged,
                isInitialPageLoad
            }
        };
    },

    updateCancellationPolicy(cancellationPolicy) {
        return {
            type: ACTIONS.UPDATE_CANCELLATION_POLICY,
            payload: {
                cancellationPolicy
            }
        };
    },

    failedOnQuoteLoad() {
        return {
            type: ACTIONS.FAILED_QUOTE_CANCELLATION_POLICY_LOAD,
            payload: {failedOnQuoteLoad: true}
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
